import React, { Component, createRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import { toast, ToastContainer } from 'react-toastify/dist';
import HelpdeskApiCall from 'HelpdeskApiCall';
import 'HELPDESK/CommonResources/BookmarkModal/bookmarkmodal.css';
import { faBookmark } from '@fortawesome/free-regular-svg-icons';
import { X, Lock, LockOpen, Bookmark } from 'lucide-react'
import searchIcon from "HELPDESK/CommonResources/images/search-icon.svg";



export class BookMarkModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // VARIABLES FOR FETCHING EVENT DETAILS
      moduleDetailsList: {},
      bookmarkModalListStatus: false,
      bookmarkModalList: {},



      moduleSearchName: '',
      bookMarkModuleId: null,
      groupedModules: {},
      bookmarkModalObject: {},
      isBookmarkActionInProgress: false,
      // need to  dont allow to click until add or remove api call resolve give proper name boolean variable



    };
    this.modalRef = createRef(); // Create a ref for the modal
  }

  componentDidMount() {
    // METHOD CALLED TO GET EVENT DETAILS
    this.apiCallToGetSummaryToGetTotalModuleList();
    this.apiCallToGetBookmarkModuleList();
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside); // click outside the event
  }
  handleClickOutside = (event) => {
    if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
      this.props.handleClose(); // Close modal if clicked outside
    }
  };
  // New Summary Design
  // API CALL TO GET BOOK TOTAL AVAILABLE MODULE LIST
  apiCallToGetSummaryToGetTotalModuleList = async () => {


    // summary_getTotalModuleList()
    this.setState({ modalDetailsListStatus: true });
    // **remark**"Only 'iid' and 'projectId' are mandatory
    let requestData = {
      iid: config.institute_id,
      userId: config.faculty_id,
      searchKeyWord: this.state.moduleSearchName,
    };

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      "summary_getTotalModuleList",
      requestData,
      "/api/summary/summaryModuleBookmark.php"
    );


    if (jsonResponse.expired) {
      setTimeout(() => {
        this.apiCallToGetSummaryToGetTotalModuleList();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let tasksArray = [];
        let sortedIdArray = jsonResponse.APIResult.sorted_key;
        sortedIdArray.map((uid) => {
          tasksArray.push(jsonResponse.APIResult.data[uid]);
        })

        if (jsonResponse.APIResult.data) {

          this.setState({
            moduleDetailsList: tasksArray,

            modalDetailsListStatus: false,

          });
          const groupedModules = this.state.moduleDetailsList.reduce((acc, module) => {
            const firstLetter = module.moduleName.charAt(0).toUpperCase();
            if (!acc[firstLetter]) acc[firstLetter] = [];
            acc[firstLetter].push(module);
            return acc;
          }, {});
          this.setState({ groupedModules: groupedModules });
        } else {
          this.setState({
            moduleDetailsList: [],
            modalDetailsListStatus: false,
          });
          toast.error(jsonResponse.APIResult.message);

        }
      } else {
        // toast.error(jsonResponse.message);
        console.log('Something went wrong While Loading total module list');
        this.setState({
          modalDetailsListStatus: false,
          moduleDetailsList: [],
        });




      };
    }
  }
  // PRESS ENTER TO SEARCH MODULE  LIST

  handleModalSearchKeyPress = (event) => {
    if (event.key == 'Enter') {
      this.apiCallToGetSummaryToGetTotalModuleList();
    }
  }

  // API CALL TO GET BOOK MARK LIST MODAL
  apiCallToGetBookmarkModuleList = async () => {
    // summary_getTotalModuleList()
    this.setState({ bookmarkModalListStatus: true });
    // **remark**"Only 'iid' and 'projectId' are mandatory
    let requestData = {
      iid: config.institute_id,
      facultyId: config.faculty_id,
    };

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      "summary_getModuleBookmarks",
      requestData,
      "/api/summary/summaryModuleBookmark.php"
    );


    if (jsonResponse.expired) {
      setTimeout(() => {
        this.apiCallToGetBookmarkModuleList();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        const bookmarkModalData = jsonResponse.APIResult.data || {};
        if (jsonResponse.APIResult.success === 'true') {

          if (Object.keys(bookmarkModalData).length > 0) {
            this.setState({
              bookmarkModalList: bookmarkModalData,
              bookmarkModalListStatus: false,
            });

          } else {
            toast.error(jsonResponse.APIResult.message);
            this.setState({
              bookmarkModalList: {},
              bookmarkModalListStatus: false,
            });
          }
        } else {
          toast.error(jsonResponse.APIResult.message);
          this.setState({
            bookmarkModalList: {},
            bookmarkModalListStatus: false
          });
        }


      } else {
        toast.error("Something went wrong when getting the bookmark list.");
        this.setState({
          bookmarkModalList: {},
          bookmarkModalListStatus: false,
        });




      };
    }
  }

  // API CALL TO GET BOOKMARK MODULE
  apiCallToAddBookmarkModule = async () => {
    this.setState({ isBookmarkActionInProgress: true });
    let requestData = {
      iid: config.institute_id,
      facultyId: config.faculty_id,
      moduleId: this.state.bookMarkModuleId,
    };

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      "summary_addModuleBookMarks",
      requestData,
      "/api/summary/summaryModuleBookmark.php"
    );


    if (jsonResponse.expired) {
      setTimeout(() => {
        this.apiCallToAddBookmarkModule();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        if (jsonResponse.APIResult.status === 'success') {

          // Only add module if it's not already in the list
          if (Object.keys(this.state.bookmarkModalList).length < 6 && !this.state.bookmarkModalList[this.state.bookMarkModuleId]) {
            this.setState((prevState) => ({
              bookmarkModalList: {
                ...prevState.bookmarkModalList, // Keep previous modules
                [this.state.bookMarkModuleId]: this.state.bookmarkModalObject // Add new module
              },
            }));
          }
          this.apiCallToGetSummaryToGetTotalModuleList();
          toast.success(jsonResponse.APIResult.message);
          // In success/failure cases, reset the flag
          this.setState({ isBookmarkActionInProgress: false });

        } else {
          toast.warning(jsonResponse.APIResult.message);

          this.setState({
            bookMarkModuleId: null,
            isBookmarkActionInProgress: false
            // openBookMarkModal: false
          });

        }




      } else {
        toast.error("Something went wrong While Adding Bookmark");

        this.setState({
          bookMarkModuleId: null,
          isBookmarkActionInProgress: false
        });
      };
    }

  }
  //  API CALL TO REMOVE REMOVE BOOKMARK MODULE
  apiCallToRemoveBookmarkModule = async () => {
    let requestData = {
      iid: config.institute_id,
      facultyId: config.faculty_id,
      moduleId: this.state.bookMarkModuleId,
    };

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      "summary_removeModuleBookmarks",
      requestData,
      "/api/summary/summaryModuleBookmark.php"
    );
    if (jsonResponse.expired) {
      setTimeout(() => {
        this.apiCallToRemoveBookmarkModule();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        if (jsonResponse.APIResult.status === 'success') {
          this.setState({
            bookmarkModalList: Object.values(this.state.bookmarkModalList)
              .filter((bookmark) => bookmark.moduleId !== this.state.bookMarkModuleId)
              .reduce((acc, bookmark) => ({ ...acc, [bookmark.moduleId]: bookmark }), {}), // Convert back to object
            bookMarkModuleId: null,
          });
          this.apiCallToGetSummaryToGetTotalModuleList();
          toast.success(jsonResponse.APIResult.message);
          // In success/failure cases, reset the flag
          this.setState({ isBookmarkActionInProgress: false });


        } else {
          toast.warning(jsonResponse.APIResult.message);
          this.setState({
            bookMarkModuleId: null,
            isBookmarkActionInProgress: false

            // openBookMarkModal: false
          });


        }
      } else {
        toast.error("Something went wrong While Removing Bookmark");

        this.setState({
          bookMarkModuleId: null,
          isBookmarkActionInProgress: false
        });
      }
    }
  }
  // IF BOOKED THEN REMOVE or NOT BOOKED , THEN BOOKED 
  bookMarkModule = async (moduleInfo) => {

    this.setState({
      bookMarkModuleId: moduleInfo.moduleId,
      bookmarkModalObject: moduleInfo
    }, () => {
      if (moduleInfo.bookmarked === 'yes') {
        this.apiCallToRemoveBookmarkModule();
      } else {
        this.apiCallToAddBookmarkModule();
      }


    });

  }


  render() {
    let isModulePresent = false;
    Object.keys(this.state.groupedModules)
      .sort()
      .map((letter) => {
        // Filter the modules before displaying
        const filteredModules = this.state.groupedModules[letter].filter((module) =>
          module.moduleName.toLowerCase().includes(this.state.moduleSearchName.toLowerCase())
        );

        if (filteredModules.length > 0) {
          isModulePresent = true;
        };
      });
    return (
      <div className={this.props.openBookMarkModal ? "modal fade in" : "modal fade"} id="modalContainer" style={{ display: this.props.openBookMarkModal ? 'block' : 'none' }}>
        <div className="modal-content workspace-current-modal-mode bookmark-mobile-mode"
          style={{
            position: "absolute",
            top: "3rem",
            right: "0",
            zIndex: 9999,
            width: '65vw',
            minWidth: '65vw',
            height: "calc(100vh - 4rem)", // Takes remaining height
            overflowY: 'auto',
          }}
          ref={this.modalRef}
        >
          {/* BOOK MARK LIST */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '15px', }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginRight: '20px' }}>
              <p className='vm_custom_bottom' style={{ color: '#808080', marginLeft: '32px', fontWeight: 600 }}>Bookmarked Modules</p>
              <div className="config-icon-background-rounded cursor-pointer" onClick={this.props.handleClose}>
                <X size={18} />
              </div>
            </div>
            <div className="row tabsDesignSummary" style={{ padding: '0px 0px 16px 32px', borderBottom: '1px solid #C1CDD7' }}>
              {
                Object.keys(this.state.bookmarkModalList).length > 0 ?
                Object.values(this.state.bookmarkModalList).map((bookmarkModal, index) => (

                  <div
                    className={'col-md-2 BookedModule workspace-current-bookmark-cell-color'}
                    key={index}
                    style={{ display: 'flex', gap: '15px' }}
                  >
                    <a
                      href={`${config.RootUrl}${bookmarkModal.moduleRoute}`}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      key={index}
                    >
                      <span title={bookmarkModal.moduleName} style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center', cursor: 'pointer' }} onClick={() => this.handleTabChange(bookmarkModal)}>
                        <FontAwesomeIcon
                          icon={bookmarkModal.icon}
                          style={{ height: '16px', width: '16px' }}
                          className='ws-fwm-icon-color'
                        />
                        <p className='vm_custom_body3 text-truncate' style={{ maxWidth: '100px' }}>
                          {bookmarkModal.moduleName}
                        </p>
                      </span>
                    </a>
                  </div>))
                  :
                  <p className='vm_custom_body11' style={{ textAlign: 'center', width: '100%' }}>
                  <span>Please use the</span><span>  <FontAwesomeIcon icon={faBookmark} style={{ color: '#808080' ,marginRight:3}} /></span><span> bookmark icon in front of each module in the list below to save them for quick access.</span>
                </p>

              }


            </div>
          </div>

          <div className="custom-form-body scrollable-div" style={{ gap: '0px', marginTop: '15px', minHeight: '65vh', overflow: 'auto' }}>

            <div style={{ display: 'flex', position: 'static', flexWrap: 'wrap', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '0px 20px 0px 32px' }}>
              <p className='vm_custom_bottom' style={{ color: '#808080' }}>Module list</p>
              {/* Search Filter */}


              {/* Based On task Title */}
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                <div className="filteredInput">

                  <div>
                    <div style={{ position: "relative" }}>
                      <input
                        type="text"
                        className="form-control custom-placeholder ws-placeholder-search-text-color"
                        id="orgID"
                        placeholder="Search by module name "
                        value={this.state.moduleSearchName}
                        onChange={(e) => this.setState({ moduleSearchName: e.target.value.toLowerCase() })}
                        // onKeyPress={this.handleModalSearchKeyPress}
                        style={{ height: '40px', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: 'auto', border: '1px solid #0465AC' }}
                      />
                      <div className="bg-white px-1" style={{ zIndex: 1, position: "absolute", top: "50%", left: 4, transform: "translateY(-50%)", pointerEvents: "none", }}>
                        <img src={searchIcon} style={{ width: "18px", height: "18px" }} />
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>


            {/* Map All the  */}
            <div className="container col-md-12" style={{ margin: 0, padding: 0 }}>
              <div className="row">
                {(Object.keys(this.state.groupedModules).length > 0 && isModulePresent) ? (
                  Object.keys(this.state.groupedModules)
                    .sort()
                    .map((letter) => {
                      // Filter the modules before displaying
                      const filteredModules = this.state.groupedModules[letter].filter((module) =>
                        module.moduleName.toLowerCase().includes(this.state.moduleSearchName.toLowerCase())
                      );

                      if (filteredModules.length === 0) return null;
                      return (
                        <div key={letter} style={{ width: '100%', padding: '20px 20px 20px 32px' }}>
                          <p className='vm_custom_subtitle3' style={{ textTransform: "capitalize", fontSize: 20, fontWeight: '500' }}>
                            {letter}
                          </p>
                          <div className="row-container">
                            {filteredModules.map((modal, index) => (
                              <div key={index} className="customModuleBookMark workspace-current-bookmark-cell-color">
                                <a
                                  href={modal.subscriptionStatus == 'yes' && `${config.RootUrl}${modal.moduleRoute}`}
                                  style={{ textDecoration: 'none', color: 'inherit' }}
                                  key={index}

                                >
                                  <span style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    <FontAwesomeIcon
                                      icon={modal.icon}
                                      className='ws-fwm-icon-color'
                                      style={{ height: '1rem', width: '1rem' }}
                                    />
                                    <span style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                      <span className='d-flex flex-row align-items-center' style={{ display: 'flex', gap: '8px' }}>
                                        <p className="vm_custom_body3" title={modal.moduleName} style={{ fontWeight: 'bold'}}>
                                          {modal.moduleName.split(" ").slice(0, 2).join(" ")} <br />
                                          {modal.moduleName.split(" ").slice(2).join(" ")}
                                        </p>
                                        <span className={`${modal.subscriptionStatus === 'no' ? 'bg-grey-subscription-color' : 'ws-lock-subscription-color'}`} style={{ cursor: 'pointer', fontSize: '14px' }}>
                                          {
                                            modal.subscriptionStatus === 'no' ? <Lock size='12' color="#000" /> : <LockOpen size='12' color="#000"/>
                                          }
                                        </span>
                                      </span>
                                      <span className='vm_custom_caption'>{modal.description}</span>
                                    </span>
                                  </span>
                                </a>
                                <span className='vertical-line-bookmark'></span>
                                <span
                                  className="material-symbols-rounded"
                                  style={{ cursor: this.state.isBookmarkActionInProgress ? "not-allowed" : "pointer", fontSize: "18px" }}
                                  onClick={() => !this.state.isBookmarkActionInProgress && this.bookMarkModule(modal)}
                                >
                                  {
                                      modal.bookmarked === 'no' ? (
                                        <FontAwesomeIcon icon={faBookmark} style={{ color: '#808080' }} />
                                      ) : (
                                          <Bookmark size='22' fill='#000' />
                                        )
                                  }

                                </span>
                              </div>
                            ))

                            }
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <p className='vm_custom_body11' style={{ textAlign: 'center', width: '100%' }}>
                    No results found. Please refine your search.
                  </p>
                )}
              </div>

            </div>







          </div>
          <ToastContainer />
        </div>
      </div>
    )
  }
}
export default BookMarkModal
